import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'components/base';
import { HtmlContent } from 'components/rich';

import PdpIcon from '../product/pdpIcon';

// SEO copy from the content file (extraDescription). Phones show the first paragraph with
// Read more, the full text stays in the DOM.
const LandingEditorial = ({ eyebrow, title, html }) => {
  const [open, setOpen] = useState(false);
  if (!html) return null;

  return (
    <section className="lnd-section lnd-editorial">
      <Container className="lnd-editorial-inner">
        <div className="lnd-editorial-head">
          <p className="lnd-eyebrow">{eyebrow}</p>
          <h2 className="lnd-h2 lnd-h2--small">{title}</h2>
        </div>
        <div className={`lnd-editorial-body${open ? ' open' : ''}`}>
          <HtmlContent html={html} />
          {!open && (
            <button type="button" className="lnd-read-more" onClick={() => setOpen(true)}>
              Read more
              <PdpIcon name="chevronDown" size={14} />
            </button>
          )}
        </div>
      </Container>
    </section>
  );
};

LandingEditorial.propTypes = {
  eyebrow: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  html: PropTypes.string,
};

export default LandingEditorial;
